<template>
    <analytics-marketing-subscriptions-total-opt-ins
        :startDate="startDate"
        :endDate="endDate"
        class="col-span-12 sm:col-span-6 lg:col-span-4"
        minHeight="172px"
    >
        <template v-slot:subtitle> Last 30 days </template>
    </analytics-marketing-subscriptions-total-opt-ins>
    <analytics-outbound-messages-total-messages-sent-by-message-type
        class="col-span-12 sm:col-span-6 lg:col-span-4"
        :fetchParams="{range: [startDate, endDate]}"
        minHeight="172px"
    >
        <template v-slot:subtitle> Last 30 days </template>
    </analytics-outbound-messages-total-messages-sent-by-message-type>

    <vx-box class="p-6 flex flex-col justify-between gap-2 col-span-12 lg:col-span-4">
        <div>
            <h3 class="text-base font-extrabold text-slate-800 mb-1">More Analytics</h3>
            <p class="text-xs font-normal text-slate-400">
                Visit the analytics page for more in depth coverage.
            </p>
        </div>

        <vx-button href="/analytics/dashboard" class="mt-2 lg:mt-0" size="lg" block color="primary">
            Analytics
            <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
        </vx-button>
    </vx-box>
</template>

<script setup>
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton } from '@voxie/frontend-components';

import AnalyticsMarketingSubscriptionsTotalOptIns from '~/components/analytics/charts/time-series/AnalyticsMarketingSubscriptionsTotalOptIns.vue';
import AnalyticsOutboundMessagesTotalMessagesSentByMessageType from '~/components/analytics/charts/time-series/AnalyticsOutboundMessagesTotalMessagesSentByMessageType.vue';

import { getDateRange } from '../../utils/analytics';

const { start_date: startDate, end_date: endDate } = getDateRange('last_30_days');
</script>
